import { render } from "./AcceptanceApprovalHistoryDetail.vue?vue&type=template&id=433bdced&scoped=true"
import script from "./AcceptanceApprovalHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./AcceptanceApprovalHistoryDetail.vue?vue&type=script&lang=ts"

import "./AcceptanceApprovalHistoryDetail.vue?vue&type=style&index=0&id=433bdced&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-433bdced"

export default script